<template>
    <div>
        <div class="dx-fieldset">
            <div class="dx-field">
                <div class="dx-field-label">Select a Tenant to Access Request</div>
                <div class="dx-field-value">
                    <DxSelectBox 
                    :search-enabled="true"
                    :data-source="gridDataSource" 
                    :search-mode="searchModeOption"
                    :search-expr="searchExprOption"
                    :search-timeout="searchTimeoutOption"
                    :min-search-length="minSearchLengthOption" :show-data-before-search="showDataBeforeSearchOption"
                    :accept-custom-value="true" 
                    display-expr="name" 
                    value-expr="id" 
                    :value="gridBoxValue"
                     ref="rltfld"
                     @value-changed="onValueChanged" />
                </div>
            </div>
        </div>
    <ul class="instruction">
        <li>
            Choose the tenant you want to request access to. Tenants represent different organizations or groups.
        </li>
        <li>
            If you don't see the desired tenant, please contact the administrator for assistance.
        </li>
    </ul>
    </div>
</template>

<script>
import { DxSelectBox } from 'devextreme-vue/select-box';
import CustomStore from "devextreme/data/custom_store";
let relateRoute;

function setRelatedRoute(context) {
    relateRoute = context.rRoute;
}

export default {
    props: {
        rRoute: String,
        slug: String,
        modelValue: String,
    },
    components: {
        DxSelectBox,
        CustomStore

    },
    data() {
        return {
            gridDataSource: null,
            gridBoxValue: "",
            searchModeOption: 'contains',
            searchExprOption: 'name',
            searchTimeoutOption: 200,
            minSearchLengthOption: 0,
            showDataBeforeSearchOption: true,
        };
    },
    created() {
        this.gridDataSource = this.makeAsyncDataSource("customers.json");

        relateRoute = this.rRoute;


    },
    methods: {
        makeAsyncDataSource(rRoute, slug) {
            console.log("RELATE COMPONENT world", rRoute, slug);

            return new CustomStore({

                key: "id",
                loadMode: 'processed',
                load: function (loadOptions) {
                //rlt-fld-list
                   // let listurl = "/" + "builder" + "/" + "tenant-lists" + "/list";
                    let listurl = "/" + "builder" + "/" + "tenant-lists" + "/rlt-fld-list";
                    //  let listurl = "/" + slug + "/" + rRoute + "/field/rlt_fld_build_relate";

                    console.log("RELATE COMPONENT list url", listurl)

                    var parameters = {};

                    var tFilter = [loadOptions.searchExpr, loadOptions.searchOperation, loadOptions.searchValue];

                    if (loadOptions.sort) {
                        parameters.order_column = loadOptions.sort[0].selector;
                        if (loadOptions.sort[0].desc) parameters.order_direction = "asc";
                    }
                    if (loadOptions.searchExpr != null && loadOptions.searchValue != null) {
                        parameters.filter = JSON.stringify(tFilter);
                    }
                    var config = {
                        params: parameters,
                    };

                    return axios
                        .get(listurl, config)
                        .then((response) => {

                            console.log("Tenant Request COMPONENT Response", response.data.results.data);
                            return {
                                data: response.data.results.data,
                                totalCount: response.data.results.total,
                            };
                        })
                        .catch(() => {
                            throw "Data Loading Error";
                        });
                },
                byKey: function (key) {

                    if (key != null || key !== 'undefined') {

                        let url = "/" + "builder" + "/" + "tenant-lists" + '/getById/' + key;
                        return axios
                            .get(url)
                            .then((response) => {
                                console.log("Tenant Request COMPONENT byKey Response", response);

                                return {
                                    id: response.data.data.id,
                                    name: response.data.data.name,
                                };
                            })
                            .catch(() => {
                                throw "Data Loading Error";
                            });
                    }

                    //return { id: key, name: "Unknown" };
                },

            });
        },

        onValueChanged(e) {
            this.gridBoxValue = e.value;
        this.$emit("update:modelValue", e.value);
        },
    },
    mounted() {
        this.gridBoxValue = this.modelValue;

    },
};
</script>

<style>
.instruction{
    margin:70px 15px 0px 15px;
}
ul {
    list-style-type: square;
    padding: 0;
    /* margin: 70px 15px 0px 15px; */
}

li {
    margin-bottom: 3px;
    color: grey;
    /* background-color: #f0f0f0;
      padding: 2px;
      border-radius: 4px; */
}
</style>